import { render, staticRenderFns } from "./TrendingIcon.vue?vue&type=template&id=1cbc9d42&"
import script from "./TrendingIcon.vue?vue&type=script&lang=ts&"
export * from "./TrendingIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports